var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_19166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66671 2.66634V1.33301H11.3334V2.66634H14.6667V3.99967H13.3334V13.9997C13.3334 14.1765 13.2631 14.3461 13.1381 14.4711C13.0131 14.5961 12.8435 14.6663 12.6667 14.6663H3.33337C3.15656 14.6663 2.98699 14.5961 2.86197 14.4711C2.73695 14.3461 2.66671 14.1765 2.66671 13.9997V3.99967H1.33337V2.66634H4.66671ZM4.00004 3.99967V13.333H12V3.99967H4.00004ZM6.00004 5.99967H7.33337V11.333H6.00004V5.99967ZM8.66671 5.99967H10V11.333H8.66671V5.99967Z",
    fill: "#00897B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_19166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash6);
export default __webpack_public_path__ + "static/media/trash6.24cc271c.svg";
export { ForwardRef as ReactComponent };